import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Route } from 'vue-router'
import { UserModule } from '@/store/modules/user'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/reset-password']

router.beforeEach((to: Route, from: Route, next: any) => {
  NProgress.start()
  if (whiteList.includes(to.path)) {
    next()
  } else if (!UserModule.isLogin) {
    UserModule.GetUserInfo().then(() => {
      next()
    }).catch(() => {
      next('/login')
    })
  } else {
    next()
  }
})

router.afterEach(() => {
  NProgress.done()
})
